import { useNavigate } from "react-router-dom"
import { Box, HStack, Spacer, Stack, VStack } from "@chakra-ui/react"
import { Text } from "@/components"
import { Deal } from "@/types"

interface Props {
  deal: Deal
}

export const DealListItem = ({ deal }: Props) => {
  const navigate = useNavigate()

  return (
    <VStack
      cursor="pointer"
      bg="white"
      borderRadius={10}
      boxShadow="sm"
      _hover={{ boxShadow: "lg" }}
      w="100%"
      align="stretch"
      onClick={() => navigate(`/clients/${deal.client.id}`)}
    >
      <Stack p={5} w="100%" gap={3}>
        <HStack w="100%">
          <Text fontSize={{ base: "lg", md: "2xl" }} fontWeight="bold">
            {deal.company.name}
          </Text>
          <Spacer />
          <Box px={3} py={1} bg="brand.25" borderRadius="md">
            <Text fontSize="xs" color="white">
              {deal.currentStep.replace(/_/g, " ")}
            </Text>
          </Box>
        </HStack>
        <Text fontSize="md">
          {deal.client.firstName} {deal.client.lastName}
        </Text>
        <Text fontSize="sm" color="gray.500">
          {deal.client.email}
        </Text>
      </Stack>
    </VStack>
  )
}
